import axios, { AxiosRequestConfig } from "axios";
import config from "./index"
import { publishWeb } from "../services/navigate.service";
import { refreshAccessToken } from "./tokenRefresh";
import { notAuthorizedCodes } from "./notAuthorizedCodes";
const baseURL = config.api.baseUrl;

const AxiosInstance = axios.create({
    baseURL: baseURL,
});

AxiosInstance.interceptors.request.use(
    function (request: AxiosRequestConfig<any> | any) {
        request.headers["Authorization"] = `Bearer ${getLocalAccessToken()}`;
        return request;
    },
    function (error: any) {
        return Promise.reject(error);
    }
);

// Add a response interceptor
AxiosInstance.interceptors.response.use(
    async function (response: any) {
        return response;
    },
    async function (error: any) {
        const config: AxiosRequestConfig<any> | any = error.config;
        // A blob download gets the API error as a Blob; decode it so the 401 check and error toasts can read it.
        if (error.response && typeof Blob !== "undefined" && error.response.data instanceof Blob) {
            const text = await error.response.data.text().catch(() => "");
            try { error.response.data = JSON.parse(text); } catch { error.response.data = { message: text }; }
        }

        if (
            error.response?.status === 401 &&
            config &&
            !config._retry &&
            error.response.data &&
            notAuthorizedCodes.includes(error.response.data.message)
        ) {
            config._retry = true;
            try {
                const failedToken = String(config.headers?.["Authorization"] ?? "").replace(/^Bearer /, "");
                const newAccess = await refreshAccessToken(failedToken);
                config.headers["Authorization"] = `Bearer ${newAccess}`;
                return AxiosInstance(config);
            } catch (err) {
                return Promise.reject(error);
            }
        }
        if (error.response?.status === 400 && error.response.data?.message === "Session expired or invalid") {
            publishWeb("refreshTokenFailed", {
                title: "Logged In on Another Device",
                desc: "Your session ended due to a login from another device. Please secure your account if it wasn't you.",
            });
        }
        return Promise.reject(error);
    }
);

const getLocalAccessToken = () => {
    return localStorage.getItem("accessToken")
};

export default AxiosInstance;
